import { styled } from "@mui/material/styles";
const PickupDetailsMain = styled("div")(({ theme }) => ({
  marginTop: "35px",
  paddingBottom: "40px",
  [theme.breakpoints.down("md")]: {
    paddingBottom: "30px",
  },
}));
const InputFlexWrap = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  marginBottom: "5px",
  gap: "20px",
  "& .AuthInputMain": { width: "100%" },
}));
export { PickupDetailsMain, InputFlexWrap };
